import $ from 'jquery';

const bannerLoad = () => {
	const bannerLocalStorage = window.bannerLocalStorage; //
	const banner = $('.js--banner');
	const bannerLink = $('.js--banner_inner');
	const bannerImgEl = $('.js--banner_image');
	const bannerCircleEl = $('.js--banner_circle');
	const bannerCloseEl = $('.js--close_banner');
	const bannerIndentEl = $('.js--banner-indent');
	const bannerOtherIndentEl = $('.js--other-banner-indent'); // for other full height section
	const bannerIndentClass = 'is--banner';
	const bannerIndentClassClose = 'is--banner-close';
	const bannerIndentClassToBody = 'is--banner-open';
	const headerFixedEl = $('.header.mod-header__fixed .header__container .menu-header');
	const headerFixedNewEl = $('.js-header.header-main');
	const mobileBurgerEl = $('.js-menu-header-mobile-toggle');
	const headerStatic = $('.header-main--static');
	const headerDynamic = $('.header-main--dynamic');
	let angle = 0;
	let inter;
	const bannerCircle = degree => {
		bannerCircleEl.css({'-webkit-transform': 'rotate(' + degree + 'deg)', '-moz-transform': 'rotate(' + degree + 'deg)', '-ms-transform': 'rotate(' + degree + 'deg)', '-o-transform': 'rotate(' + degree + 'deg)', transform: 'rotate(' + degree + 'deg)'});
	};
	const body = $('body');

	banner.mouseenter(function () {
		inter = setInterval(function () {
			angle += 0.1;
			bannerCircle(angle);
		}, 1);
	}).mouseleave(function () {
		clearInterval(inter);
	});
	$(window).on('resize', function () {
		if (!localStorage.getItem(bannerLocalStorage) && $('header').hasClass('header_style_main')) {
			bannerIndentEl.css({height: $(window).height() - banner.outerHeight(true) + 'px'});
		}
		if (!localStorage.getItem(bannerLocalStorage) && bannerOtherIndentEl.length > 0) {
			bannerOtherIndentEl.css({height: $(window).height() - banner.outerHeight(true) - 80 + 'px'});
		}
	});
	const headerScrollFixed = () => {
		const bannerHeight = banner.outerHeight();
		let headerTop;
		mobileBurgerEl.css('position', 'absolute'); //
		if (headerFixedEl.length > 0) {
			headerTop = headerFixedEl.offset().top + 'px';
		}
		if (headerFixedNewEl.length > 0) {
			headerTop = headerFixedNewEl.offset().top + 'px';
		}
		if ($(window).scrollTop() > 0) {
			if (bannerHeight - $(window).scrollTop() > 0) {
				headerTop = bannerHeight - $(window).scrollTop() + 'px';
			} else {
				headerTop = 0;
				mobileBurgerEl.css('position', 'fixed'); //
			}
		} else {
			headerTop = 'auto';
		}
		headerFixedEl.css('top', headerTop);
		headerFixedNewEl.css('top', headerTop);
		headerStatic.css('top', headerTop);
		headerDynamic.css('top', headerTop);
	};
	const bannerInner = () => {
		const bannerH = banner.outerHeight(true);
		banner.slideDown(700, function () { headerScrollFixed(); });
		if ($('header').hasClass('header_style_main')) {
			bannerIndentEl.css({height: $(window).height() - bannerH + 'px'});
		}
		if (bannerOtherIndentEl.length > 0) {
			bannerOtherIndentEl.css({height: $(window).height() - bannerH - 80 + 'px'});
		}
		setTimeout(function () {
			banner.addClass('active');
		}, 800);
		setTimeout( function () {
			bannerImgEl.addClass('active');
		}, 1500);
	};
	const bannerOpen = timer => {
		banner.css({position: 'relative', display: 'none', opacity: '1'});
		if ($('header').hasClass('header_style_main')) {
			bannerIndentEl.addClass(bannerIndentClass);
		}
		if (bannerOtherIndentEl.length > 0) {
			bannerOtherIndentEl.addClass(bannerIndentClass);
		}
		setTimeout(function () {
			bannerInner();
			body.addClass(bannerIndentClassToBody);
		}, timer);
	};
	const bannerClose = type => {
		if (type) {
			banner.slideUp(1);
		} else {
			banner.slideUp(700, function () {
				bannerIndentEl.addClass(bannerIndentClassClose);
				bannerOtherIndentEl.addClass(bannerIndentClassClose);
				body.addClass(bannerIndentClassClose);
				bannerIndentEl.removeClass(bannerIndentClass);
				bannerOtherIndentEl.removeClass(bannerIndentClass);
				body.removeClass(bannerIndentClassToBody);
				mobileBurgerEl.css('position', 'fixed'); //
				if ($('header').hasClass('header_style_main')) {
					bannerIndentEl.css({height: 'calc(100vh)'});
				}
				if (bannerOtherIndentEl.length > 0) {
					bannerOtherIndentEl.css({height: 'calc(100vh - 80px)'});
				}
			});
		}
	};

	// $(window).on('load', function () {
	// 	if (!localStorage.getItem(bannerLocalStorage)) {
	// 		bannerOpen(1000);
	// 	}
	// });

	$(document).ready(function () {
		if (!localStorage.getItem(bannerLocalStorage)) {
			bannerOpen(300);
		}
	});

	$(window).on('scroll', function () {
		if (!localStorage.getItem(bannerLocalStorage)) {
			headerScrollFixed();
		}
	});

	bannerCloseEl.on('click', function (e) {
		localStorage.setItem(bannerLocalStorage, 'true');
		bannerClose();
		e.preventDefault();
	});

	bannerLink.on('click', function () {
		if ($(this).attr('data-close')) {
			localStorage.setItem(bannerLocalStorage, 'true');
		}
	});

};

const render = () => {
	bannerLoad();
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/banner/banner.js